import $ from 'jquery';
import * as types from '../actions/actionTypes';
import {IS_LIXIL_UI, UseFullSizeImages} from "../config";
import {getLoadedPresetKey} from "../misc/presetsFunctions";
import {LAYERS_SIZES} from "../misc/utils";

const initialState = {
  bvOpened: IS_LIXIL_UI,
  bvVisited: false,
  canvasId: "",
  bvFeatures: [],
  bvPresets: [],
  allVisualizersPresets: {},
  requestedVisualizerPresets: [], // visType
  activePreset: 0,
  loadedPresets: [], // keys ("kitchen-1", "bathroom-2", see getLoadedPresetKey) of already loaded presets (in order not to download them twice)
  presetWasChangedByUser: null, // preset id that user has clicked
  firstLoadedPreset: null, // the one that was loaded first (from url or job id, etc.)
  showRestorePopup: true,
  canvasDimensions: LAYERS_SIZES.normal,
  staticCanvasImage: window.location.href.includes("formwood_industries")
    ? "https://qc-static.s3.us-west-1.amazonaws.com/fabricator-static-files/Formwood+Stagnate+Vis.jpg"
    : "",
  canvasCount: 0,
  canvasScale: 1,
};

export default function(state = initialState, action) {

  switch(action.type) {

    case types.TOGGLE_BATHROOM_VISUALIZER_OPEN:
      if (action.payload.bvOpened) {
        setTimeout(() => {  // set timeout is needed because of BV menu wrapper blur click
          document.body.classList.add('body--bv');
          $(window).trigger('resize');
        }, 0);
      } else {
        setTimeout(() => {  // set timeout is needed because of BV menu wrapper blur click
          document.body.classList.remove('body--bv');
        }, 0)
      }

      return Object.assign({}, state, {
        bvOpened: action.payload.bvOpened,
        bvVisited: true
      });
    case types.SET_BV_CANVAS_ID:
      return {...state, canvasId: action.payload.id};
    case types.SET_BV_FEATURES:
    case types.TOGGLE_SHOW_RESTORE_POPUP:
    case types.SET_BATHROOM_VISUALIZER_VISITED:
    case types.SET_STATIC_CANVAS_IMAGE:
    case types.SET_PRESET_WAS_CHANGED_BY_USER:
    case types.SET_FIRST_LOADED_PRESET:
    case types.SET_CANVAS_SCALE:
      return Object.assign({}, state, {
        ...action.payload
      })
    case types.SET_BV_PRESETS:
      return Object.assign({}, state, {
        ...action.payload,
        allVisualizersPresets: Object.assign({}, state.allVisualizersPresets, {
          [action.payload.visualizerType || document.kvConfig.visualizerType]: action.payload.bvPresets
        })
      })
    case types.REQUEST_BV_PRESETS:
      return Object.assign({}, state, {
        requestedVisualizerPresets: [...state.requestedVisualizerPresets, action.payload]
      })
    case types.UPDATE_FABRICATOR_SETTINGS: // update when visualizer is changed
      return Object.assign({}, state, {
        bvPresets: state.allVisualizersPresets[document.kvConfig.visualizerType] || []
      })
    case types.SET_LOADED_PRESETS: // merge, so keys of other visualizer types are kept
      return Object.assign({}, state, {
        loadedPresets: [...new Set([...state.loadedPresets, ...action.payload.loadedPresets])]
      })
    case types.SET_ACTIVE_PRESET: {
      const presetKey = getLoadedPresetKey(action.payload.activePreset);
      const loadedPresets = state.loadedPresets.includes(presetKey)
        ? state.loadedPresets
        : [...state.loadedPresets, presetKey];
      return Object.assign({}, state, {
        loadedPresets,
        ...action.payload
      })
    }
    case types.UPDATE_CANVAS_COUNT:
      return Object.assign({}, state, {
        canvasCount: state.canvasCount + 1
      })
    case types.SET_CANVAS_DIMENSIONS:
      // eslint-disable-next-line no-case-declarations
      const canvasDimensions = action.payload.canvasDimensions
        ? Object.assign({}, action.payload.canvasDimensions)
        : document.kvConfig.layersSize === "full_hd"
          ? UseFullSizeImages ? LAYERS_SIZES.full_hd_large : LAYERS_SIZES.full_hd
          : UseFullSizeImages ? LAYERS_SIZES.large : LAYERS_SIZES.normal
      if (canvasDimensions && canvasDimensions.width) {
        switch (canvasDimensions.width) {
          case LAYERS_SIZES.large.width:
          case LAYERS_SIZES.full_hd_large.width: {
            document.body.classList.add('bv--full-size');
            break;
          }
          case LAYERS_SIZES.full_hd.width: {
            document.body.classList.add('bv--full-hd');
            break;
          }
          default:
            break;
        }
      }
      return Object.assign({}, state, {canvasDimensions})
  }

  return state;

}
